import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';

const SeoSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section seo-section hp-section">
      <div className="seo-copy">
        <h2>{t('seoHeader')}</h2>
        <p>{t('seoCopy')}</p>
      </div>
    </section>
  );
};

export default SeoSection;
